import type { CategoryValue } from "../components/CategoryCombobox";

export interface CategoryPatch {
  categoryId?: string;
  categoryName?: string;
}

/**
 * Decide how a scenario patch should reference its category.
 *
 * A hydrated scenario starts as `{ kind: "existing", id: "", name }` — the
 * server returns only the category NAME, and the id is filled in later by an
 * async reconcile against the loaded category list. If the user saves or
 * uploads before that reconcile lands (or the name never matches a known
 * category), `id` is still empty.
 *
 * We must NOT send `categoryId: ""` in that window: the server treats a
 * present-but-empty categoryId as "provided" and rejects the whole update with
 * `400 "Either categoryId or categoryName must be provided"`. So when there is
 * no resolved id, fall back to the name — the server resolves categoryName
 * case-insensitively (upsertCategoryByName), which finds the existing row.
 */
export function categoryPatch(value: CategoryValue): CategoryPatch {
  if (!value) return {};
  if (value.kind === "existing" && value.id) {
    return { categoryId: value.id };
  }
  // "new", or "existing" whose id hasn't reconciled yet — reference by name.
  if (value.name.trim()) {
    return { categoryName: value.name };
  }
  return {};
}
